import { useEffect, useMemo, useRef } from 'react';
import util from '../util';

const useDeepMemo = (memo, deps) => {
	const depsRef = useRef(deps);
	const didUpdate = !util.deepEqual(deps, depsRef.current);

	// Update the ref only when dependencies change
	useEffect(() => {
		if (didUpdate) {
			depsRef.current = deps;
		}
	}, [didUpdate, deps]); // Ensure `deps` is included to avoid stale references

	// Return memoized value based on deep equality check
	return useMemo(memo, [didUpdate]); 
};

export default useDeepMemo;
